<template>
  <!-- <ShipmentsSceduleContent :view="'map'"></ShipmentsSceduleContent> -->
   <div id="map-container" ref="map"></div>
</template>

<script>
// import { shipmentHelper } from '@/_helpers'
import { mapActions, mapGetters } from 'vuex'
import LocationDelivery from '@/assets/mapPoint1PL.svg'
import LocationPickup from '@/assets/mapPoint.svg'
import { hereMapsService } from '@/_services'
export default {
  name: 'ShipmentsGroupByDayMap',
  components: {
    // ShipmentsSceduleContent
  },
  props: {},
  data () {
    return {
      hereMap: null,
      herePlatform: null,
      hereDefaultLayer: null,
      hereMapBehaviors: null,
      hereMapControl: null,
      // hereMapUI: {
      //   source: null,
      //   mapSettings: null,
      //   zoom: null,
      //   scalebar: null,
      //   mode: null
      // },
      hereMarker1PL: null,
      hereMarkerIcon: null,
      hereMapGroup: null,
      hereMapRouteLine: null,
      isLoading: true,
      hereMapUI: null
    }
  },
  created () {},
  mounted () {
//     this.initializeHereMap({ element: this.$refs.map, files: [point1PL
// , mapPoint], locale: this.$i18n.locale })
  },
  methods: {
    ...mapActions({
      initializeHereMaps: 'shipmentsMap/initializeHereMaps',
      calculateHereMapsRoute: 'shipmentsMap/calculateHereMapsRoute',
      setHereMapsMap: 'shipmentsMap/setHereMapsMap',
      setHereMapsDefaultLayer: 'shipmentsMap/setHereMapsDefaultLayer',
      setHereMapsBehaviors: 'shipmentsMap/setHereMapsBehaviors',
      setHereMapMarkers: 'shipmentsMap/setHereMapMarkers',
      setHereMapsPlatform: 'shipmentsMap/setHereMapsPlatform',
      setHereMapsUI: 'shipmentsMap/setHereMapsUI'
    }),
    initializeHereMap () {
      if (!this.getMapIsInitialized) {
        this.herePlatform = hereMapsService.hereMapsPlatform()
        this.setHereMapsPlatform({ platform: this.herePlatform })
        this.hereDefaultLayer = hereMapsService.hereMapsDefaultLayer({ platform: this.herePlatform })
        this.setHereMapsDefaultLayer({ defaultLayer: this.hereDefaultLayer })
        this.hereMap = hereMapsService.hereMap({
          element: this.$refs.map,
          defaultLayer: this.hereDefaultLayer
        })
        this.setHereMapsMap({ map: this.hereMap })
        this.hereMapBehaviors = hereMapsService.hereMapsBehaviors({ map: this.hereMap })
      } else {
        this.herePlatform = this.getHereMapPlatform
        this.hereDefaultLayer = this.getHereMapDefaultLayer
        this.hereMap = this.getHereMap
        this.hereMapBehaviors = this.getHereMapBehaviors
        
      }
      this.isLoading = false
    },
    calculateHereMapRoute () {
      var routing = this.herePlatform.getRoutingService()
      const schedule = this.getSelectedShipmentScheduleForMap
      const hasPort = schedule.findIndex(({ type }) => {
        return type === 'LocationOriginAirPort' || type === 'LocationOriginOceanPort' || type === 'LocationDestinationAirPort' || type === 'LocationDestinationOceanPort'
      })
      if( hasPort >= 0 ) {
        this.drawHereMapStraightLine(schedule)
        this.drawHereMapMarkers(this.routingMarkers)
        this.drawHereMapMarkersBubbles(this.routingMarkers)
      } else {
        routing.calculateRoute(this.routingOptions, this.onRoutingResult.bind(null, this.routingMarkers), this.onRoutingError)
      }
    },
    onRoutingResult (markers, result) {
      result.response.route.forEach((route) => {
        this.drawHereMapRoute(route)
        this.drawHereMapMarkers(markers)
        this.drawHereMapMarkersBubbles(markers)
      })
    },
    onRoutingErrorChangeMode (error) {
      this.hereRoutingMode = 'fastest;car'
      this.calculateHereMapRoute(this.shipmentLocations.map(({ _geoloc }) => _geoloc), this.shipmentLocations)
    },
    onRoutingError (error) {
      console.log(error)
    },
    drawHereMapRoute (route) {
      let routeShape = route.shape
      let lineString = new window.H.geo.LineString()
      routeShape.forEach((point) => {
        lineString.pushLatLngAlt(point.split(',')[0], point.split(',')[1])
      })
      let routeLine = new window.H.map.Polyline(lineString, {
        style: {
          strokeColor: '#4CAF50',
          fillColor: 'transparent',
          lineWidth: 3
        }
      })
      if (this.hereMapRouteLine != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapRouteLine)
        this.hereMapRouteLine = null
      }
      this.hereMapRouteLine = routeLine
      this.hereMap.addObject(routeLine)
      this.hereMap.getViewModel().setLookAtData({
        bounds: routeLine.getBoundingBox(),
        zoom: 4
      })
    },
    drawHereMapStraightLine (stops) {
      const lineString = new H.geo.LineString()
      stops.forEach((item) => {
        lineString.pushPoint({ lat: item.location.coordinates.lat, lng: item.location.coordinates.lng })
      })
      if (this.hereMapRouteLine != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapRouteLine)
        this.hereMapRouteLine = null
      }
      const routeLine = new H.map.Polyline(
        lineString, { style: { lineWidth: 4 } },
      )
      this.hereMapRouteLine = routeLine
      this.hereMap.addObject(routeLine)
    },
    drawHereMapMarkers (markers) {
      let group = new window.H.map.Group()
      if (this.hereMapGroup != null && this.hereMap != null) {
        this.hereMap.removeObject(this.hereMapGroup)
        this.hereMapGroup = null
      }
      this.hereMapGroup = group
      group.addObjects(markers)
      this.hereMap.addObject(group)
      this.hereMapUI = hereMapsService.hereMapsUI({defaultLayer: this.hereDefaultLayer, map: this.hereMap})
    },
    drawHereMapMarkersBubbles (markers) {
      console.log(this.getSelectedShipmentScheduleForMap)
      console.log(markers)
      // let group = new window.H.map.Group()
      let self = this
      let shipment = this.getSelectedShipmentScheduleForMap
      markers.forEach((marker, index) => {
        // for (let i = 0; i < shipment.length; i++) {
        //   marker.setData(
        //     `<div class="custom--timeline__body--card">
        //   <div class="custom--timeline__body--card--text"><span class="custom--timeline__body--card--text__title">
        //   ${shipment[i].organization != null ? shipment[i].location.organization.name : ''}
        //   </span><span  class="custom--timeline__body--card--text__subtitle">
        //   ${shipment[i].location.organization.ref}</span></div>
        //   <div class="custom--timeline__body--card--text"><span class="custom--timeline__body--card--text__title">
        //   ${this.$options.filters.AddressObjectToString(shipment[i].location.address, [['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])}
        //   </span><span  class="custom--timeline__body--card--text__subtitle">
        //   ${shipment[i].location.ref}</span></div>
        //   </div>`)
        // }
        

        marker.addEventListener('tap', function (evt) {
          console.log(evt.target.getData())
          let bubble = new window.H.ui.InfoBubble(evt.target.getGeometry(), {
            content: evt.target.getData(),
          })
          
          self.hereMapUI.source.addBubble(bubble)
        })
      })
    },
    isCoordinatesInDrops (val) {
      if (val[0].origin != null) {
        if (val[0].origin.coordinates != null) {
          return true
        }
      }
      return false
    }
  },
  computed: {
    ...mapGetters({
      getMapIsInitialized: 'shipmentsMap/getMapIsInitialized',
      getMapIsInitializing: 'shipmentsMap/getMapIsInitializing',
      getHereMapRouting: 'shipmentsMap/getHereMapRouting',
      getHereMap: 'shipmentsMap/getHereMap',
      getMapRoutingOptions: 'shipmentsMap/getMapRoutingOptions',
      getMapRoutingMarkers: 'shipmentsMap/getMapRoutingMarkers',
      getMapIsRouting: 'shipmentsMap/getMapIsRouting',
      getHereMapPlatform: 'shipmentsMap/getHereMapPlatform',
      getHereMapDefaultLayer: 'shipmentsMap/getHereMapDefaultLayer',
      getHereMapBehaviors: 'shipmentsMap/getHereMapBehaviors',
      getSelectedShipmentScheduleForMap: 'shipmentsContext/getSelectedShipmentScheduleForMap',
    }),
    routingOptions () {
      return this.getMapRoutingOptions
    },
    routingMarkers () {
      return this.getMapRoutingMarkers
    }
  },
  watch: {
    getSelectedShipmentScheduleForMap: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val != null) {
          this.$nextTick(() => {
            this.initializeHereMap()
            this.calculateHereMapsRoute({
              locations: val,
              files: [{ file: LocationDelivery, name: 'LocationDelivery' }, { file: LocationPickup, name: 'LocationPickup' }]
            })
          })
        }
      }
    },
    getMapIsInitializing: {
      immediate: true,
      handler(val, oldVal) {
        if (!val && oldVal) {
          this.$nextTick(() => {
            this.calculateHereMapRoute()
          })
        }
      }
    }
  },
  beforeDestroy () {
    // this.removeHereMapObject()
  }
}
</script>

<style lang="scss" scoped>
#map-container {
  width: 100%;
  height: calc(100vh - 120px);
}
</style>
